<template>
    <div class="product-description">
        <ProductComponent :isCreate="true"></ProductComponent>
    </div>
</template>

<script>
    import ProductComponent from "./components/ProductComponent";
    export default {
        name: "ProductDescription",
        components: {
            ProductComponent
        },
        data(){
            return {
                activeName: "description"
            }
        }
    }
</script>

<style scoped>

</style>
